export default __webpack_public_path__ + "static/media/info-circle-fill.13a7ece4.svg";